$(document).ready(function() {
  $('#new-project-type').change(function() {
    if ($('#new-project-type').val() == 'fix') {
      $('#new-project-fix-price-input').show()
      $('#new-project-range-price-input').hide()
    }

    if ($('#new-project-type').val() == 'range') {
      $('#new-project-fix-price-input').hide()
      $('#new-project-range-price-input').show()
    }

    if ($('#new-project-type').val() == 'auction') {
      $('#new-project-fix-price-input').hide()
      $('#new-project-range-price-input').hide()
    }

  })

  $('#i-have-an-idea').click(function () {
    if (this.checked) {
      $('#new-project2-idea-section').show(0)
      $('#just-idea-input').hide(300)
    } else {
      $('#new-project2-idea-section').hide(0)
      $('#just-idea-input').show(300)
    }
  })

  $('.js-add-more-links').click(function() {
    $('.add-podpost-add-more-links').show(300)
    $(this).hide(0)
  })
})